// extracted by mini-css-extract-plugin
module.exports = {"vimeoContainer":"styles_vimeoContainer__3BDdb","vimeoPlayer":"styles_vimeoPlayer__2QT5e","text":"styles_text__29SfW"};